import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useEmailApiClient } from '@/api/clients/useEmailApiClient.util.ts';
import { AttachmentStateDto } from '@/api/generated';
import { useUserContext } from '@/contexts/userContext/User.context.ts';

type Req = {
  attachmentId: string;
  emailId: string;
};

type Return = {
  getAttachmentState: (req: Req) => Promise<AttachmentStateDto>;
  isErrorGettingAttachmentState: boolean;
  isGettingAttachmentState: boolean;
};

export const useGetAttachmentState = (): Return => {
  const { emailReaderApi } = useEmailApiClient();
  const { userId } = useUserContext();

  const { isError, isPending, mutateAsync } = useMutation<AttachmentStateDto, AxiosError, Req>({
    meta: { disableSuccessAlert: true },
    mutationFn: async req => {
      const { data } = await emailReaderApi.getAttachmentState(
        userId,
        req.emailId,
        req.attachmentId,
      );
      return data;
    },
  });

  return {
    getAttachmentState: mutateAsync,
    isErrorGettingAttachmentState: isError,
    isGettingAttachmentState: isPending,
  };
};
